/**
 * Copyright (c) 2023 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { trim } from '@utils/lodash';

export function getSafeId(text: string) {
  return trim(text).replace(new RegExp(' ', 'g'), '-');
}
